module.exports = __webpack_public_path__ + "img/img3.8e7dad28.svg";